import type { ReactNode } from 'react';
import { cn } from './cn.js';

export type StatusTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

/** Fill alone carries the tone — an outline on top of a tint reads as a box within a box. */
const TONES: Record<StatusTone, string> = {
  neutral: 'bg-surface-alt text-muted',
  success: 'bg-success/10 text-success',
  warning: 'bg-warning/10 text-warning',
  danger: 'bg-danger/10 text-danger',
  info: 'bg-brand-soft text-brand',
};

export interface StatusBadgeProps {
  tone?: StatusTone;
  children: ReactNode;
  className?: string;
}

export function StatusBadge({ tone = 'neutral', children, className }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
